import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  h1 {
    font-size: 40px;
    font-weight: 600;
    line-height: 30px;
    color: ${(props) => props.theme.color.text.secondary};
  }
  h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    color: ${(props) => props.theme.color.text.tertiary};
  }
  p {
    font-family: 'Poppins';
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: ${(props) => props.theme.color.text.primary};
    text-align: center;

    a {
      color: ${(props) => props.theme.color.text.secondary};
      font-weight: 700;
    }
  }
`;
